{
  "OPTIONAL": "Optional",
  "BOOLEAN": {
    "YES": "Yes",
    "NO": "No"
  },
  "URGENCY": {
    "HIGH": "High",
    "LOW": "Low"
  },
  "APP": {
    "VERSION": "This app is running on version {version}"
  },
  "BUTTONS": {
    "NEXT": "Next",
    "SKIP": "Skip",
    "CONFIRM": "Confirm",
    "CLOSE": "Close",
    "CANCEL": "Cancel",
    "SHOW_ALL": "Show all",
    "HIDE": "Hide"
  },
  "FOOTER": {
    "HOME": "Home",
    "WORK": "Work",
    "TOOLBOXES": "Toolboxes",
    "PROFILE": "Profile"
  },
  "WORK": {
    "EMPTY_STATE_TITLE": "No projects yet",
    "EMPTY_STATE_MESSAGE": "Projects will appear soon."
  },
  "HOME": {
    "PRODUCT_NAME": "i-LOP",
    "PRODUCT_NAME_BETA": "BETA",
    "CHECK_IN_STATUS": {
      "CHECKED_IN": "Checked in",
      "CHECKED_OUT": "Checked out",
      "CHECK_IN": "Check in",
      "CHECK_OUT": "Check out"
    },
    "TO_FULFILL": "To fulfill",
    "CHECKLISTS": "Checklists",
    "CERTIFICATES": "Certificates",
    "SAFETY_INSTRUCTIONS": "Safety Instructions",
    "TOOLBOXES": "Toolboxes",
    "NOT_ASSIGNED_TO_PROJECT": {
      "TITLE": "No active project",
      "MESSAGE": "You are not yet registered to a project. Find a project to get started!",
      "BUTTON": "Find project"
    },
    "ALERTS": "Project messages",
    "NO_ALERTS": "There are currently no messages",
    "CURRENT_CHECK_IN": "Currently checked in",
    "LAST_PROJECT": "Last project",
    "CHECKED_IN_AT": "Checked in at {time}",
    "LAST_CHECKED_IN": "Last checked in at {time}",
    "CHECKED_OUT_AT": "Checked out at {time}",
    "FOREMAN": {
      "WORKERS_ON_SITE": "Workers on site",
      "START_WORK_INSTRUCTION": "Start Werk Instructie",
      "CREATE": "+ Create"
    }
  },
  "SAFETY_INSTRUCTIONS": {
    "TITLE": "Safety Instructions",
    "ALL_COMPLETED": "All required safety instructions are completed"
  },
  "SAFETY_INSTRUCTION": {
    "PREVIOUS": "Previous",
    "NEXT": "Next",
    "FINISH": "Finish",
    "QUESTION_HINT_AT_LEAST_ONE": "Please select at least one correct answer",
    "QUESTION_HINT_ALL_CORRECT": "Please select all correct answers",
    "QUESTION_ERROR_ALL_CORRECT": "These are not the correct answers, please try again",
    "QUESTION_CORRECT": "Correct answer!",
    "QUESTION_ERROR_UNANSWERED": "Please provide correct answers to all questions before continuing"
  },
  "LOGIN": {
    "EMAIL_LABEL": "Email",
    "PASSWORD_LABEL": "Password",
    "EMAIL_PLACEHOLDER": "Enter your email address",
    "PASSWORD_PLACEHOLDER": "Enter your password",
    "LOGIN_BUTTON": "Log in",
    "LOG_IN": "Log in",
    "FORGOT_PASSWORD": "Forgot password?",
    "LOGIN_WITH_YIVI": "Continue with Yivi",
    "YIVI_HELP": "Use Yivi to sign in or create your account.",
    "PASSWORD_LOGIN": "Log in with password"
  },
  "FORGOT_PASSWORD": {
    "TITLE": "Forgot password",
    "DESCRIPTION": "Enter your email address for us to send you password recovery email",
    "EMAIL_LABEL": "Email",
    "EMAIL_PLACEHOLDER": "Enter your email address",
    "SUCCESS_MESSAGE_1": "We sent a confirmation email to",
    "SUCCESS_MESSAGE_2": "Check your email and click on the confirmation link to continue",
    "SUBMIT_BUTTON": "Submit",
    "RESEND_BUTTON": "Resend email"
  },
  "RESET_PASSWORD": {
    "TITLE": "Reset password",
    "DESCRIPTION": "Create a new, strong password, that you don’t use for other websites",
    "PASSWORD_LABEL": "New password",
    "PASSWORD_PLACEHOLDER": "Enter your new password",
    "VERIFY_PASSWORD_LABEL": "Verify new password",
    "VERIFY_PASSWORD_PLACEHOLDER": "Enter your new password again",
    "PASSWORD_MISMATCH": "Passwords do not match",
    "RESET_BUTTON": "Reset password",
    "INVALID_TOKEN": "The email address is invalid or token has expired. Please request a new password reset",
    "SUCCESS_TITLE": "Success!",
    "SUCCESS_MESSAGE": "Your password has been reset successfully. You can now log in with your new password.",
    "LOGIN": "Log In",
    "INVALID_LINK_TITLE": "Invalid reset link",
    "INVALID_LINK_MESSAGE": "This password reset link is invalid or has expired. Please request a new password reset.",
    "REQUEST_NEW_LINK": "Request new reset link"
  },
  "ACCEPT_INVITATION": {
    "INTRO": {
      "TITLE": "Invitation",
      "DESCRIPTION": "You have been invited to an employment. Review the details and accept to get started.",
      "SUBSCRIPT": "This invitation link can be used only once and expires in 7 days.",
      "BUTTON": "Accept invitation"
    },
    "OFFER": {
      "ORGANISATION": "Organisation",
      "FUNCTION": "Function",
      "START_DATE": "Start date",
      "END_DATE": "End date",
      "INVITED_AS": "Invited as"
    },
    "ACCEPT_ON_PHONE": {
      "TITLE": "Accept on your phone",
      "DESCRIPTION": "Scan this code with your phone's camera to open this invitation in the i-LOP app."
    },
    "SIGN_IN_TO_ACCEPT": "Sign in to accept",
    "SUCCESS": {
      "TITLE": "Invitation accepted!",
      "DESCRIPTION": "Your employment is now linked to your account.",
      "BUTTON": "Continue"
    },
    "ALREADY_ACCEPTED": {
      "TITLE": "Already accepted",
      "DESCRIPTION": "This invitation has already been accepted."
    },
    "NOT_INVITABLE": {
      "TITLE": "Invitation no longer valid",
      "DESCRIPTION": "This employment is no longer available. Please contact your employer."
    },
    "EXPIRED": {
      "TITLE": "Invitation expired",
      "DESCRIPTION": "This invitation link has expired. Please ask your employer to send a new invitation."
    },
    "INVALID_LINK": {
      "TITLE": "Invalid invitation link",
      "DESCRIPTION": "This invitation link is invalid. Please contact your administrator to request a new invitation."
    }
  },
  "ERRORS": {
    "AUTHENTICATION": {
      "USER_ALREADY_EXISTS": "Email address already in use",
      "INVALID": "Your email address or password is incorrect",
      "TRY_LATER": "You cannot log in at the moment, please try again later",
      "TOKEN_NOT_VALID": "You need to log in again",
      "YIVI_FAILED": "Yivi sign-in could not be completed"
    },
    "PROJECT_SELECT": {
      "ALREADY_ASSIGNED": "You are already assigned to this project.",
      "NOT_ASSIGNED": "You are not assigned to this project."
    },
    "QRCODE_SCANNER": {
      "NO_PERMISSION": "No permission to use the camera",
      "INVALID": "The QR code is invalid",
      "EXPIRED": "The QR code has expired",
      "NO_PROJECT_SELECTED": "Choose the project you want to verify against first",
      "NO_PROJECT_TO_VERIFY": "You don't run any project here, so there is no project to verify this worker against",
      "PROJECTS_UNAVAILABLE": "Your projects could not be loaded. Check your connection and scan again",
      "IDENTITY_NOT_RESOLVED": "The QR code does not belong to a single app account"
    },
    "AVATAR": {
      "TOO_LARGE": "The photo file is too large. Choose a smaller photo.",
      "DIMENSIONS_TOO_LARGE": "The photo is too big. Choose a smaller photo.",
      "UNSUPPORTED_IMAGE_TYPE": "This file type cannot be used as a profile photo. Choose a JPEG, PNG or WebP image.",
      "MALFORMED_IMAGE": "The photo could not be read. Try another photo.",
      "INVALID_IMAGE": "The photo cannot be used as a profile photo."
    },
    "GENERIC": "Something went wrong",
    "NETWORK": "Cannot connect to server",
    "NOT_FOUND": "Cannot find something",
    "UNKNOWN": "An unknown error has occurred",
    "OFFLINE": "You are not online",
    "NOT_CHECKED_IN": "You are not checked in to a project",
    "CONTENT_OUTSTANDING": "Finish every instruction and toolbox before signing.",
    "INVALID_SIGNATURE": "That signature could not be read. Draw it again.",
    "NO_PROJECT_ACCESS": "You have no access to this project",
    "NO_ACCESS": "You do not have permission for this",
    "INVITATION_INVALID": "The invitation link is not valid.",
    "INVITATION_EXPIRED": "The invitation link has expired. Ask your employer to send a new one.",
    "EMPLOYMENT_ALREADY_ACCEPTED": "This employment is already linked to another account.",
    "EMPLOYMENT_NOT_INVITABLE": "This employment can no longer be accepted.",
    "PERSON_BINDING_CONFLICT": "This person record is linked to another app account. Contact your administrator.",
    "GATE_ENTRY_REQUIRES_EXCEPTION": "This worker is missing requirements, so letting them in has to be registered as an exception.",
    "PERSON_NOT_BOUND": "This person does not have an app account yet.",
    "PERSON_NO_PROJECT_ACCESS": "The scanned person has no access to this project",
    "PERSON_ALREADY_CHECKED_IN": "The scanned person is already checked in to this project",
    "SUBJECT_NOT_FOUND": "The scanned person's account could not be found",
    "SUBJECT_NOT_CHECKED_IN": "This worker is not checked in to this project, so they cannot be admitted here"
  },
  "QRCODE_SCANNER": {
    "TITLE": "Scanning",
    "SCAN_QR_CODE": "Scan QR code",
    "RETRY_SCAN_QR_CODE": "Scan QR code again",
    "CAMERA_PERMISSION_DENIED_EXPLANATION": "Open settings and give permission to use the camera",
    "OPEN_SETTINGS": "Open settings",
    "SCAN_AGAIN": "Scan next",
    "VERIFY_AGAINST": "Verify for project",
    "VERIFY_AGAINST_PLACEHOLDER": "Choose a project"
  },
  "SELECT": {
    "DEFAULT_TITLE": "Select an option",
    "DEFAULT_MULTISELECT_TITLE": "Select one or more options"
  },
  "ONBOARDING": {
    "LOG_IN": "Log in",
    "WELCOME_MESSAGE": "Welcome to the learning and development platform."
  },
  "YIVI_REGISTRATION": {
    "TITLE": "Finish your account",
    "DESCRIPTION": "We received your identity details from Yivi. Complete the remaining iLOP information to continue.",
    "BIRTH_DATE": "Birth date",
    "GENDER": "Gender",
    "SUBMIT": "Create account",
    "CANCEL": "Cancel"
  },
  "GENDER": {
    "MALE": "Male",
    "FEMALE": "Female",
    "OTHER": "Other"
  },
  "SAVED_WORK": {
    "BUTTON_TITLE": "Saved"
  },
  "NOTIFICATION": {
    "DISMISS": "Close"
  },
  "PROFILE": {
    "PERSONAL_INFORMATION": "Personal information",
    "NAME": "First name",
    "SURNAME": "Last name",
    "NICKNAME": "Preferred name",
    "NICKNAME_PLACEHOLDER": "Enter your preferred name (optional)",
    "CERTIFICATES": "Certificates",
    "SAVE": "Save",
    "SELECT_FUNCTION": "Select function",
    "LOGOUT": "Log out",
    "TOAST": {
      "SAVED": "Personal information has been saved",
      "ERROR": "An error occurred while saving personal information"
    },
    "AVATAR": {
      "ACTION_SHEET_TITLE": "What do you want to do?",
      "CHANGE_LABEL": "Change profile photo",
      "DELETE_LABEL": "Delete profile photo",
      "CANCEL_LABEL": "Cancel",
      "RESIZE_ERROR": "The photo could not be processed. Try another photo.",
      "CROP_TITLE": "Crop photo",
      "CROP_CONFIRM": "Use photo",
      "CROP_ZOOM_LABEL": "Zoom"
    },
    "SETTINGS": "Settings",
    "SETTINGS_ROUTES": {
      "CHANGE_PASSWORD": "Change password"
    },
    "PASSWORD": {
      "LABEL_CURRENT": "Current password",
      "PLACEHOLDER_CURRENT": "Enter your current password",
      "LABEL_NEW": "New password",
      "PLACEHOLDER_NEW": "Enter your new password",
      "LABEL_VERIFY_NEW": "Verify new password",
      "PLACEHOLDER_VERIFY_NEW": "Enter your new password again",
      "BUTTON_LABEL": "Change password",
      "TOAST": {
        "SUCCESS": "Password has been changed. Log in again with your new password",
        "ERROR": "An error occurred while changing the password"
      },
      "FORM_VALIDATION_MISMATCH": "The new passwords do not match"
    }
  },
  "PROJECT_DETAILS": {
    "TITLE": "Project details",
    "SWI_SIGNED": "SWI signed",
    "SWI_OPEN": "SWI open",
    "SWI_SIGNED_COUNT": "{count} SWI signed",
    "SWI_SIGNED_OF": "{signed} of {total} SWI signed",
    "REPORT_SAFETY_RISKS": "Report safety risks",
    "SEE_SAFETY_REPORTS": "Open safety reports",
    "CONTRACTOR": "Contractor",
    "CLIENT": "Client",
    "SELECT": "Select",
    "WORKERS": "Workers",
    "DESELECT": "Deselect",
    "WORKERS_EMPTY_STATE": "No workers have registered to this project yet.",
    "UNKNOWN_EMPLOYER": "Employer unknown",
    "CERTIFICATES": "Required project certificates",
    "TOOLBOXES": "Required project toolboxes",
    "TOOLBOXES_ALL_COMPLETED": "All required toolboxes are completed",
    "ALERTS": "Messages",
    "CREATE_ALERT": "Add message",
    "ALERTS_EMPTY_STATE": "There are currently no messages for this project",
    "MAIN_OFFICE": "Headquarters",
    "CHECK_IN": "Check in",
    "CHECK_OUT": "Check out",
    "AT_WORK": "{count} at work",
    "REQUIREMENTS_CHECKLIST": "Project requirements",
    "OVERWRITE_CHECKIN_TITLE": "Check in",
    "OVERWRITE_CHECKIN_MESSAGE": "You are currently checked in to \"{projectName}\". Checking in here ends that check-in.",
    "OVERWRITE_CHECKIN_CONFIRM": "Check in",
    "OVERWRITE_CHECKIN_CANCEL": "Cancel"
  },
  "PROJECT_SELECT": {
    "TITLE": "Select project",
    "PROJECT_NAME": "Project name",
    "PROJECT_FUNCTION": "Function in project",
    "SELECT_AT_LEAST_ONE_FUNCTION": "Select at least one function.",
    "EMPLOYEE": "Employee",
    "NEXT": "Next",
    "ALREADY_CHECKED_IN_TITLE": "Already checked in",
    "ALREADY_CHECKED_IN_MESSAGE": "You are already checked in to this project. There is nothing you need to do.",
    "INVALID_CODE": "This project code is no longer valid. Ask the site supervisor for the current one.",
    "REPORT_TO_FOREMAN_TITLE": "Report to the site supervisor",
    "REPORT_TO_FOREMAN_MESSAGE": "You are checked in, but you are not registered on this project. Report to the site supervisor straight away."
  },
  "PROJECT_SELECT_CONFIRM": {
    "ALL_FULFILLED": "All requirements are fulfilled",
    "BUTTON": "Confirm",
    "TITLE": "Confirm project selection"
  },
  "PROJECT_SELECT_SUCCESS": {
    "SUCCESS": "Success!",
    "SELECTED": "You have registered for the project.",
    "DESELECTED": "You have deregistered from the project.",
    "BUTTON": "Home"
  },
  "CERTIFICATE": {
    "EXPIRED": "Expired on {date}",
    "VALID_UNTIL": "Valid until {date}",
    "EXPIRES_IN": "Expires in {duration}",
    "EXPIRES_SOON": "Expires within 3 months",
    "EXPIRES_NEVER": "Never expires",
    "MISSING": "Not yet obtained",
    "PENDING": "Pending review",
    "REJECTED": "Rejected",
    "VIEW_DOCUMENT": "Document",
    "VIEW_DOCUMENT_N": "Document {n}",
    "REGISTERED_TO": "Registered to {name}"
  },
  "DOCUMENT_INPUT": {
    "ADD": "Add photo or PDF",
    "TAKE_PHOTO": "Take photo",
    "CHOOSE_FROM_LIBRARY": "Choose from library",
    "CHOOSE_PDF": "Choose PDF",
    "REMOVE": "Remove",
    "CANCEL": "Cancel"
  },
  "ADD_CERTIFICATE": {
    "TITLE": "Add certificate",
    "CERTIFICATE": "Certificate",
    "CERTIFICATE_NUMBER": "Certificate number",
    "ISSUED_ON": "Issued on",
    "EXPIRES_ON": "Expires on",
    "DOCUMENT": "Document",
    "MISSING_FIELDS": "Please select an organisation and certificate.",
    "ERROR": "Something went wrong. Please try again.",
    "CHOOSER": {
      "IMPORT": "Import from registry",
      "UPLOAD": "Upload document"
    }
  },
  "IMPORT_CERTIFICATE": {
    "TITLE": "Import certificate",
    "LAST_NAME": "Last name",
    "DATE_OF_BIRTH": "Date of birth",
    "REGISTRY": "Registry",
    "CERTIFICATE_NUMBER": "Certificate number",
    "MISSING_FIELDS": "Please fill in all fields.",
    "SUCCESS": "Certificate imported.",
    "STATUS": {
      "NOTFOUND": "No certificate found for these details.",
      "REGISTRYERROR": "The registry could not be reached right now. Please try again later."
    }
  },
  "CERTIFICATES": {
    "NO_CERTIFICATES": "No certificates found",
    "EXPIRED_CERTIFICATES": "Some of your certificates have expired. Renew them to continue working."
  },
  "MARKDOWN_CONTENT": {
    "TERMS_AND_CONDITIONS": "Terms and conditions",
    "PRIVACY_POLICY": "Privacy policy",
    "APP_INFO": "App information",
    "AVG_STATEMENT": "GDPR statement"
  },
  "HUMANIZE_DURATION": {
    "MONTHS": "{count, plural, =1{month} other{months}}",
    "DAYS": "{count, plural, =1{day} other{days}}",
    "SOON": "soon"
  },
  "PERSON": {
    "FIRST_NAME": "First name",
    "LAST_NAME": "Last name",
    "EMAIL": "Email address",
    "FUNCTION": "Function"
  },
  "WORKER_PROFILE": {
    "FUNCTION": "Function",
    "PROJECT": "Current project",
    "CERTIFICATES": "Certificates",
    "PROJECT_DETAILS": "Project details",
    "UPDATE_PERSON_ACTION": "Edit details",
    "ASSIGN_TO_PROJECT_ACTION": "Assign to my project"
  },
  "PHOTOS": {
    "PROFILE_PHOTO": "Choose a profile photo",
    "CANCEL": "Cancel",
    "TAKE_PHOTO": "Take a photo",
    "CHOOSE_FROM_LIBRARY": "Choose from library"
  },
  "UMA": {
    "MY_REPORTS": {
      "TITLE": "My reports",
      "EMPTY_STATE_TITLE": "No reports",
      "EMPTY_STATE_MESSAGE": "Safety risks you've reported yourself will appear here.",
      "CREATE_REPORT": "Create a report"
    },
    "REPORT": {
      "ASSIGNED_TO": "Being handled by {name}",
      "REPORTED_BY": "Reported by {name}",
      "REPORTED_BY_ANONYMOUS": "Reported anonymously"
    },
    "PROJECT_REPORTS": {
      "TITLE": "Reports for {projectName}",
      "EMPTY_STATE_TITLE": "No reports",
      "EMPTY_STATE_MESSAGE": "Safety risks reported on this project will appear here."
    },
    "CANNOT_CREATE_REPORT": {
      "TITLE": "Cannot create report",
      "DESCRIPTION": "You are not registered to a project. Register to be able to create a report."
    },
    "NEW_REPORT": {
      "CREATE_NEW_REPORT": "Create report",
      "GENERAL": {
        "FORM_TITLE": "General",
        "CATEGORY": "What would you like to report?",
        "IS_SOLVED": "Is it resolved?",
        "IS_URGENT": "Urgency",
        "IS_ANONYMOUS": "Report anonymously",
        "PROJECT": "On which project would you like to make this report?",
        "NO_PROJECTS": "You are not registered to a project. Register to be able to create a report.",
        "CHOOSE_PROJECT": "Choose a project",
        "CONFIRM_PROJECT": "You are not registered to this project. Are you sure you want to make this report?",
        "CONFIRM_PROJECT_BUTTON": "Yes, I'm sure",
        "VICTIMS": "Victims?",
        "ABSENTEEISM": "Absenteeism",
        "HOSPITALISED": "Hospitalised?",
        "HOSPITALISED_WARNING": {
          "BEFORE_PHONE": "IN CASE OF A SERIOUS ACCIDENT OR INJURY REQUIRING HOSPITALISATION, ALWAYS CALL EMERGENCY SERVICES FIRST",
          "BETWEEN_PHONE_AND_URL": "OR VIA THE ONLINE FORM:",
          "AFTER_LINK": "Consult your supervisor, the foreman or the V&G coordinator who is responsible for this report."
        }
      },
      "SITUATION": {
        "FORM_TITLE": "Situation",
        "PHOTOS": "What does the situation look like?",
        "PHOTOS_PLACEHOLDER": "Add one or more photos, or fill in a description",
        "DESCRIPTION": "Describe the situation",
        "SAFE_SITUATION_DESCRIPTION": "Safe situation",
        "RISK": "Risk",
        "DESCRIPTION_OF_SITUATION": "Situation description",
        "ACTIONS_TAKEN": "Actions taken",
        "RISK_CATEGORY": {
          "LABEL": "Risk category",
          "PLACEHOLDER": "Choose a category",
          "REQUIRED": "Category is required"
        }
      },
      "SUMMARY": {
        "TITLE": "Report submitted",
        "MESSAGE": "Report with number #{{id}} has been submitted."
      },
      "SEND": "Submit",
      "SUCCESS_TOAST": "Safety report successfully created",
      "VALIDATION": {
        "MISSING_FIELDS": "Please fill in all required fields"
      }
    },
    "REPORT_DETAILS": {
      "NOT_ASSIGNED_TO": "Not assigned to an employee",
      "ASSIGNED_TO_PERSON": "Assigned to employee",
      "ASSIGN_TO_PERSON_PLACEHOLDER": "Assign to employee",
      "DETAILS": "Details",
      "TITLE": "View report {reportId}",
      "PROJECT_NAME": "Project",
      "REPORTER": "Reporter",
      "ANONYMOUS_REPORTER": "Anonymous reporter",
      "UNKNOWN_AUTHOR": "Unknown author",
      "CATEGORY": "Report type",
      "URGENCY": "Urgency",
      "SOLVED": "Resolved",
      "PHOTOS": "Photos",
      "PHOTOS_EMPTY": "This report contains no photos",
      "DESCRIPTION": "Description",
      "RISK": "Risk",
      "CREATED_AT": "Created on",
      "CREATE_COMMENT": "Post comment",
      "COMMENTS": "Comments",
      "COMMENTS_EMPTY": "No comments have been posted yet",
      "COMMENT_BY": "Comment by {person}",
      "COMMENT_CREATED": "Comment posted successfully",
      "LOGS": "Logs",
      "LOGS_EMPTY": "There are no logs yet",
      "LOG": {
        "CREATED": "Report created by {actor}",
        "STATUS_CHANGED": "Status changed to {newStatus} by {actor}",
        "COMMENTED": "Comment posted by {actor}"
      },
      "NOT_IN_PROJECT": "Reporter was not registered to this project"
    }
  },
  "PUSH_NOTIFICATIONS": {
    "CLOSE": "Close",
    "OPEN": "Open"
  },
  "REPORT_CATEGORY": {
    "ACCIDENT": "Accident",
    "UNSAFE_SITUATION": "Unsafe",
    "SAFE_SITUATION": "Safe"
  },
  "REPORT_STATUS": {
    "NEW": "Unread",
    "IN_PROGRESS": "In progress",
    "SOLVED": "Resolved",
    "ON_HOLD": "Paused"
  },
  "NOTIFICATIONS": {
    "TITLE": "Notifications",
    "EMPTY_STATE_TITLE": "No notifications",
    "EMPTY_STATE_MESSAGE": "You will find all important notifications from the present and past here",
    "NOTIFICATION_SENT_AT_FORMAT": "d MMMM HH:mm",
    "MARK_AS_READ": "Mark as read",
    "MARK_ALL_AS_READ": "Mark all as read",
    "MARK_ALL_AS_READ_SUCCESS": "All notifications marked as read",
    "DELETE": "Delete",
    "DELETE_SUCCESS": "Notification deleted"
  },
  "REPORT_TRANSITION": {
    "NEW": "Back to new",
    "IN_PROGRESS": "Take into progress",
    "SOLVED": "Mark as resolved",
    "ON_HOLD": "Pause",
    "SOLVED_CONFIRMATION_TITLE": "Mark report as resolved?",
    "SOLVED_CONFIRMATION_MESSAGE": "Are you sure you want to mark this report as resolved?"
  },
  "SPEECH_RECOGNITION": {
    "TITLE": "Speak your text",
    "BTN_LABEL": "Speak text",
    "PERMISSION_ERROR": "Cannot speak text. No permission given. Open your phone's settings and give permission to speak text for this app.",
    "LISTENING": "Listening...",
    "USE_RESULT": "Enter result"
  },
  "CERTIFICATE_LIST": {
    "MY_EMPTY_STATE": "You have not obtained any certificates yet",
    "PERSON_EMPTY_STATE": "This employee has not obtained any certificates yet",
    "PROJECT_EMPTY_STATE": "There are no relevant certificates for this project",
    "PERSON_PROJECT_EMPTY_STATE": "There are no relevant certificates for this employee on this project"
  },
  "ALERT_CATEGORY": {
    "GENERAL": "General",
    "WEATHER": "Weather",
    "LOGISTIC": "Logistics",
    "SAFETY": "Safety"
  },
  "ALERT_DETAILS": {
    "EDIT": "Edit",
    "TITLE": "Message details",
    "CONFIRM": "Understood",
    "DELETE_TITLE": "Delete message",
    "DELETE_MESSAGE": "Are you sure you want to delete this message?",
    "DELETE_CONFIRM": "Delete",
    "DELETE_SUCCESS": "Message deleted"
  },
  "ALERT_PLAYER": {
    "PLAY": "Play",
    "PAUSE": "Pause",
    "LANGUAGE": "Language",
    "SEEK": "Progress",
    "FULLSCREEN": "Fullscreen"
  },
  "ALERT": {
    "CATEGORY": "Category",
    "TITLE": "Title",
    "DESCRIPTION": "Description",
    "VALID_FROM": "From",
    "VALID_UNTIL": "Until",
    "FROM": "from",
    "UNTIL": "until",
    "VIDEO": "Video",
    "REMOVE_VIDEO": "Remove video",
    "TYPE": "Message type",
    "TYPE_TEXT": "Text",
    "TYPE_VIDEO": "Video",
    "ADD_TARGET_AUDIENCE": "Add target audience",
    "TARGET_AUDIENCE": "Target audience",
    "TARGET_AUDIENCE_EVERYONE": "Everyone",
    "TARGET_AUDIENCE_MANAGEMENT": "Management",
    "SELECT_TARGET_AUDIENCE": "Select target audience",
    "NO_FILE_SELECTED": "No file selected",
    "CHOOSE_FILE": "Choose file",
    "TRANSLATION": "Translation",
    "TRANSLATION_DESCRIPTION": "Translate this video",
    "VIDEO_UPLOAD_FAILED": "Video upload failed",
    "AUDIENCE": {
      "MANAGEMENT": "Management",
      "ORGANISATION": "Organisation:",
      "FUNCTION": "Function:",
      "FUNCTION_GROUP": "Function group:",
      "ADD_MANAGEMENT": "Management",
      "ADD_ORGANISATION": "Organisation",
      "ADD_FUNCTION": "Function or group",
      "SELECT_ORGANISATION": "Pick an organisation",
      "NO_ORGANISATIONS": "No organisations on this project.",
      "LOADING_ORGANISATIONS": "Loading..."
    }
  },
  "NEW_ALERT": {
    "TITLE": "Add message",
    "ACTION": "Create message",
    "SUCCESS_TOAST_MESSAGE": "Message successfully created"
  },
  "EDIT_ALERT": {
    "TITLE": "Edit message",
    "ACTION": "Save changes",
    "SUCCESS_TOAST_MESSAGE": "Message successfully updated"
  },
  "EDIT_PERSON_PROJECT": {
    "TITLE": "Assign project",
    "SUCCESS_TOAST_MESSAGE": "Project assignment successfully updated"
  },
  "REASSIGN_PERSON_PROJECT": {
    "TITLE": "Assign project",
    "SUCCESS_TOAST_MESSAGE": "Project assignment successful"
  },
  "SELECT_UI": {
    "SEARCHBAR_PLACEHOLDER": "Search for an option"
  },
  "CHECKLIST": {
    "COMPLETED": "Checklist successfully completed",
    "ERROR": "Something went wrong while completing the checklist",
    "LIST_LABEL": "Checklists",
    "ALL_COMPLETED": "All required checklists are completed",
    "COMPLETE": "Complete"
  },
  "PASSWORD_COMPLEXITY": {
    "REQUIREMENTS": "Password requirements",
    "MIN_LENGTH": "At least {minLength} characters",
    "UPPERCASE": "At least one uppercase letter",
    "LOWERCASE": "At least one lowercase letter",
    "DIGIT": "At least one number",
    "SPECIAL_CHAR": "At least one special character"
  },
  "FUNCTION_SELECT": {
    "ROOT": "Root",
    "SEARCH_PLACEHOLDER": "Search for a function",
    "NO_RESULTS": "No functions found",
    "WHOLE_CATEGORY": "Whole group: {name}"
  },
  "WORKER_DETAIL": {
    "START_WORK_INSTRUCTION": "Start Werk Instructie",
    "SWI_SIGNED_ON": "Signed on {moment}",
    "NO_SWI_SIGNATURE": "Not signed yet",
    "SWI_SIGNATURE_ALT": "Signature",
    "SWI_SIGNATURE_FAILED": "The signature could not be loaded",
    "TITLE": "Worker details",
    "ITEM_STATUS": {
      "PRESENT": "Present",
      "MISSING": "Missing",
      "EXPIRED": "Expired",
      "EXPIRED_GRACE_PERIOD": "Expired (grace period)"
    },
    "CERTIFICATES": "Certificates",
    "CHECKLISTS": "Checklists",
    "SAFETY_INSTRUCTIONS": "Safety Instructions",
    "TOOLBOXES": "Toolboxes",
    "NAME": "Name",
    "VERIFIED_AGAINST": "Verified for {project}",
    "BASIC_INFORMATION": "Basic information",
    "ILOP_CONTENT": "i-LOP content",
    "NO_EMPLOYMENTS": "This worker has no active employments",
    "NO_ILOP_CONTENT": "There is no relevant i-LOP content for this worker on this project",
    "CHECK_IN": {
      "SINCE": "Checked in at"
    },
    "EMPLOYMENT": {
      "FUNCTION": "Function",
      "FROM": "From",
      "TO": "Until"
    },
    "CERTIFICATE": {
      "NUMBER": "Number",
      "ISSUED_ON": "Issued on",
      "ISSUED_FOR": "Issued for",
      "EXPIRES_ON": "Expires on"
    },
    "CONTENT": {
      "COMPLETED_ON": "Completed on",
      "MEETING_ENDED": "Meeting ended",
      "SIGNED": "Signed"
    },
    "KVK": {
      "NUMBER": "KvK number",
      "DOCUMENT_DATE": "Extract dated",
      "VALID_UNTIL": "Valid until",
      "DOCUMENT": "KvK extract"
    },
    "OPEN_DOCUMENT": "Open",
    "OPEN_DOCUMENT_FAILED": "The document could not be opened"
  },
  "GATE_ENTRY": {
    "TITLE": "Register entry",
    "GAPS_HINT": "This worker is missing requirements, so letting them in is an exception.",
    "NOT_CHECKED_IN_HINT": "This worker is not checked in to this project. Check them in to admit them, or refuse entry.",
    "CHECK_IN_WORKER": "Check worker in",
    "DECISION": {
      "VALID": "Valid",
      "EXCEPTION": "Exception",
      "DENIED": "Denied"
    },
    "REASON": {
      "HEADER_EXCEPTION": "Reason for the exception",
      "HEADER_DENIED": "Reason for refusing entry",
      "MESSAGE": "This is recorded with your name and the time.",
      "PLACEHOLDER": "Describe the reason",
      "CONFIRM": "Register"
    },
    "REGISTERED": "Entry registered"
  },
  "EMPLOYMENT": {
    "TIMELINE": {
      "TITLE": "Employment History",
      "NO_EMPLOYMENTS": "No employment history available.",
      "PRESENT": "Present",
      "ACTIVE": "Active",
      "NOT_YET_ACTIVE": "Not yet active",
      "LOAD_ERROR": "An error occurred while loading employment history.",
      "STATUS_FOR_ADMIN_REVIEW": "Under review",
      "STATUS_FOR_USER_REVIEW": "Verify your employment",
      "ADD_EMPLOYMENT": "Add",
      "REVIEW_NOTICE": "There are employments awaiting your review.",
      "REVIEW_NOTICE_ACTION": "Tap to view and review them.",
      "REVIEW_OPEN": "Review",
      "REVIEW_DETAILS_TITLE": "Review employment",
      "FUNCTION": "Function",
      "START_DATE": "Start date",
      "END_DATE": "End date",
      "MANAGERIAL": "Managerial",
      "YES": "Yes",
      "NO": "No",
      "ACCEPT": "Accept",
      "REJECT": "Reject",
      "REVIEW_ACCEPT_SUCCESS": "Employment accepted successfully.",
      "REVIEW_REJECT_SUCCESS": "Employment rejected successfully.",
      "REVIEW_ERROR": "An error occurred while reviewing the employment."
    },
    "DETAIL": {
      "TITLE": "Employment",
      "NOT_FOUND": "This employment could not be found."
    },
    "CREATE": {
      "TITLE": "Add employment",
      "ORGANISATION": "Organisation",
      "SEARCH_ORGANISATION": "Search organisation or reg. number",
      "NO_ORGANISATIONS": "No organisations found.",
      "FUNCTION": "Function",
      "START_DATE": "Start date",
      "END_DATE": "End date",
      "MANAGERIAL_LABEL": "Managerial function",
      "BUSINESS_REGISTRY_NUMBER": "Business registry number",
      "SAVE": "Save",
      "SAVE_SUCCESS": "Employment added successfully.",
      "SAVE_ERROR": "An error occurred while adding employment.",
      "LOAD_ORGANISATIONS_ERROR": "An error occurred while loading organisations.",
      "END_DATE_BEFORE_START": "End date cannot be before start date.",
      "ORGANISATION_UNAVAILABLE": "That employer is no longer available. Pick another one.",
      "FUNCTION_UNKNOWN": "That function is no longer available. Pick another one.",
      "BINDING_CONFLICT": "This employer already knows someone with your email address, under a different account. Ask them to invite you instead.",
      "IDENTITY_INCOMPLETE": "Your account is missing your name or email address, so an employer cannot register you yet. Sign in with Yivi to complete it.",
      "REQUEST_ALREADY_PENDING": "You already have a request pending at this employer. Wait for them to respond.",
      "INVITATION_PENDING": "This employer has already invited you. Accept or reject that invitation in your employment overview."
    }
  },
  "TOOLBOXES": {
    "TABS": {
      "LIST": "Toolboxes",
      "REGISTRATION": "Meetings"
    },
    "EMPTY_STATE": "No toolboxes available",
    "LAST_UPDATED": "Updated",
    "VIEW_DOCUMENT": "View document",
    "ASYNC": {
      "COMPLETED": "Toolbox completed",
      "ERROR_COMPLETING": "Failed to complete toolbox"
    },
    "FOLLOWED": {
      "TITLE": "Followed toolboxes",
      "LINK": "View followed toolboxes",
      "FILTER_CATEGORY": "Category",
      "FILTER_TYPE": "Type",
      "TYPE_SYNCHRONOUS": "Synchronous",
      "TYPE_ASYNCHRONOUS": "Asynchronous",
      "TYPE_MANUAL": "Manual",
      "NOT_AVAILABLE": "No longer available",
      "EMPTY_STATE": "You have not completed any toolboxes yet",
      "EMPTY_FILTERED": "No followed toolboxes match these filters"
    },
    "MEETING": {
      "HOST_MEETING": "Host toolbox meeting",
      "START_ANOTHER_TITLE": "Start another meeting?",
      "START_ANOTHER_MESSAGE": "You already have {count, plural, =1{one toolbox meeting} other{# toolbox meetings}} running. Start another one?",
      "START_ANOTHER_CONFIRM": "Start another",
      "ONLY_MANAGERIAL_CAN_HOST": "Only managers can host a toolbox meeting",
      "ONLY_MANAGERIAL_CAN_MANAGE": "Only managers can manage a toolbox meeting",
      "VIEW_ACTIVE_MEETING": "View active meeting",
      "SELECT_ACTIVE_MEETING": "Select a meeting",
      "MANUAL": {
        "START_BUTTON": "Start manual meeting",
        "DESCRIPTION": "Start a new manual toolbox meeting for your team as a manager.",
        "START_TITLE": "Start manual meeting",
        "ORGANISATION": "Organisation",
        "ORGANISATION_PLACEHOLDER": "Select an organisation",
        "TITLE": "Title",
        "TITLE_PLACEHOLDER": "Enter a title",
        "DESCRIPTION_PLACEHOLDER": "Optional description",
        "START_MISSING_FIELDS": "Please fill in all required fields",
        "TITLE_REQUIRED": "Title is required",
        "TITLE_NOT_ALLOWED": "Title can only be changed for manual meetings",
        "END_BEFORE_START": "End time cannot be before start time",
        "ACTIVE_LIST_TITLE": "Your toolbox meetings",
        "ACTIVE_BADGE": "In progress",
        "PLANNED_BADGE": "Planned",
        "CONTINUE_BUTTON": "Continue this meeting"
      },
      "TITLE": "Toolbox meeting",
      "PARTICIPANTS": "Participants",
      "NO_PARTICIPANTS": "No participants yet",
      "EXTERNAL_PARTICIPANT": "external",
      "INFORMATION": "Information",
      "START_DATE": "Start date",
      "END_DATE": "End date",
      "DESCRIPTION": "Description",
      "FINISH_MEETING": "Finish meeting",
      "EDIT_MEETING": "Edit meeting",
      "SAVE": "Save",
      "CANCEL": "Cancel",
      "FINISH_CONFIRMATION_TITLE": "Finish meeting?",
      "FINISH_CONFIRMATION_MESSAGE": "Are you sure you want to finish this toolbox meeting?",
      "MEETING_ENDED_TITLE": "Meeting ended",
      "MEETING_ENDED_MESSAGE": "This meeting was ended on {endTime} by {finishedByName}",
      "MEETING_ALREADY_STARTED": "A meeting has already been started by someone else",
      "ERROR_POLLING_MEETING": "An error occurred while checking for meetings",
      "ERROR_STARTING_MEETING": "Failed to start meeting",
      "ERROR_LOADING_MEETING": "Failed to load meeting",
      "ERROR_UPDATING_MEETING": "Failed to update meeting",
      "ERROR_FINISHING_MEETING": "Failed to finish meeting",
      "ERROR_END_BEFORE_START": "End time cannot be before start time",
      "SCAN_QR_CODE": "Scan QR Code",
      "RETRY_SCAN": "Retry Scan",
      "SCAN_TO_JOIN": "Scan to join",
      "JOIN_TOOLBOX_MEETING": "Join Toolbox Meeting",
      "JOIN_DESCRIPTION": "Join an existing toolbox meeting by scanning a QR code or entering a meeting code.",
      "QR_SCAN_WRONG_MEETING": "This QR code is for a different meeting",
      "QR_SCAN_ALREADY_PARTICIPANT": "You are already a participant in this meeting",
      "QR_SCAN_INVALID": "Invalid QR code format",
      "QR_SCAN_ERROR": "An error occurred while scanning",
      "QR_SCAN_NO_PERMISSION": "Camera permission is required to scan QR codes",
      "SUCCESSFULLY_JOINED": "Successfully joined the meeting",
      "ADD_PARTICIPANT": {
        "TITLE": "Add participant",
        "CHOOSE_METHOD": "Choose how you want to add a participant of this toolbox meeting: scan their i-LOP QR-code or manually enter a name",
        "SCAN_QR_CODE": "Scan QR-code",
        "MANUAL": "Manual",
        "MANUAL_ENTRY": "Manual entry",
        "OR": "or",
        "FIRST_NAME": "First name",
        "LAST_NAME": "Last name",
        "FIRST_NAME_PLACEHOLDER": "Enter first name",
        "LAST_NAME_PLACEHOLDER": "Enter last name",
        "CONFIRM": "Confirm",
        "ADDING": "Adding...",
        "SUCCESS": "Participant added successfully",
        "ERROR": "Failed to add participant",
        "MEETING_NOT_FOUND": "Meeting not found",
        "ALREADY_PARTICIPANT": "This person is already a participant in the meeting",
        "MEETING_INACTIVE": "The meeting is not active",
        "QR_VERIFY_PERMISSION_ERROR": "You don't have permission to verify this QR code. Please use manual entry instead.",
        "MISSING_PARAMETERS": "Missing required parameters for navigation",
        "NAVIGATION_ERROR": "Failed to navigate to add participant page",
        "PERSON_NOT_IN_ORGANISATION": "The scanned person does not belong to your organisation",
        "PERSON_NOT_BOUND": "This person has no app account yet. Add them as an external participant instead.",
        "PERSON_BINDING_CONFLICT": "This person is linked to multiple app accounts and cannot be added. Contact your administrator.",
        "NO_PERSON_RECORD": "This worker has an app account but is not yet employed by an organisation, so they cannot be added as a participant. Add them as an external participant instead."
      }
    }
  },
  "SIGNATURE": {
    "TITLE": "Signature",
    "INSTRUCTIONS": "Please sign below",
    "CLEAR": "Clear",
    "CONFIRM": "Confirm"
  },
  "PERSON_CHECKIN_CARD": {
    "CHECKED_IN_AT": "Checked in at:",
    "LAST_CHECKED_OUT_AT": "Last checked out at:",
    "NOT_CHECKED_IN": "Not checked in",
    "CERTIFICATES": "Certificates",
    "MORE_CERTIFICATES": "{count} more",
    "ADD_CERTIFICATE": "Add certificate"
  },
  "ZZP_COMPANY": {
    "TITLE": "Company profile (ZZP)",
    "INTRO": "Create a profile for your single-person company (ZZP).",
    "COMPANY_NAME": "Company name",
    "KVK_NUMBER": "Chamber of Commerce (KvK) number",
    "SAVE": "Save",
    "TOAST": {
      "SAVED": "Company profile has been saved",
      "ERROR": "An error occurred while saving the company profile",
      "LOAD_ERROR": "An error occurred while loading the company profile"
    },
    "KVK_EXTRACT": {
      "LABEL": "KvK extract",
      "ADD": "Add KvK extract",
      "VIEW": "View KvK extract",
      "REMOVE": "Remove",
      "UPLOADED": "KvK extract has been uploaded",
      "REMOVED": "KvK extract has been removed",
      "INVALID_TYPE": "Only PDF or image files are allowed",
      "DOCUMENT_DATE": "Date on the KvK extract",
      "VALID_UNTIL": "Valid until",
      "OUT_OF_DATE": "This KvK extract is too old. Upload a more recent one.",
      "NEEDS_DATE": "Enter the date on the extract to make it count.",
      "NEEDS_DOCUMENT": "Upload the KvK extract to make the date count."
    }
  },
  "START_WORK_INSTRUCTION": {
    "NEW_TITLE": "New SWI",
    "STEP_OF": "Step {step} of {total}",
    "NEXT": "Next",
    "LOADING": "Loading…",
    "SAVED": "Start Werk Instructie saved",
    "STEP_LABEL": {
      "PERIOD": "Date or period",
      "MESSAGES": "Messages: today’s safety instructions",
      "INSTRUCTIONS": "Instructions",
      "TOOLBOXES": "Toolboxes",
      "CHECKLISTS": "Checklists",
      "SUMMARY": "Summary",
      "NEW_MESSAGE": "New message"
    },
    "PERIOD": {
      "SINGLE_DAY": "One day",
      "RANGE": "Period",
      "DATE": "Date",
      "FROM": "From",
      "UNTIL_INCLUSIVE": "Up to and including",
      "ONE_PER_DAY_HINT": "Only one SWI can be active per day on this project.",
      "TAKEN_DAYS_HINT": "Marked days already have an SWI and cannot be picked.",
      "OVERLAP": "A Start Werk Instructie already runs in this period. Pick other dates."
    },
    "CONTENT": {
      "MESSAGES_HEADING": "Messages",
      "MESSAGES_HINT": "Only messages of type Safety are shown. You can pick several.",
      "MESSAGES_EMPTY": "No current safety messages on this project.",
      "INSTRUCTIONS_HEADING": "Instructions",
      "INSTRUCTIONS_HINT": "Only content flagged as usable in a SWI is shown here.",
      "INSTRUCTIONS_EMPTY": "No instructions available for a SWI.",
      "TOOLBOXES_HEADING": "Toolboxes",
      "TOOLBOXES_HINT": "Only content flagged as usable in a SWI is shown here.",
      "TOOLBOXES_EMPTY": "No toolboxes available for a SWI.",
      "CHECKLISTS_HEADING": "Checklists",
      "CHECKLISTS_HINT": "Only content flagged as usable in a SWI is shown here.",
      "CHECKLISTS_EMPTY": "No checklists available for a SWI.",
      "MEDIUM_VIDEO": "Video",
      "MEDIUM_DOCUMENT": "To read"
    },
    "SUMMARY": {
      "CHANGE": "Change",
      "NOTHING_SELECTED": "Nothing selected",
      "NO_CONTENT": "Pick at least one message, instruction, toolbox or checklist.",
      "SAVE": "Save",
      "PERIOD_SINGLE": "Start Werk Instructie for {date}",
      "PERIOD_RANGE": "Start Werk Instructie from {from} to {to}"
    },
    "REPEAT": {
      "HEADING": "Repeat",
      "FIRST_ENTRY": "Only on first entry to the site",
      "EVERY_ENTRY": "Every time the site is entered",
      "AFTER_ABSENCE": "Follow again after an absence",
      "ABSENCE_DAYS": "Longer than (days)",
      "ABSENCE_DAYS_RANGE": "Enter a number between {min} and {max}."
    },
    "EDIT_TITLE": "Edit SWI",
    "NEW_MESSAGE": {
      "ACTION": "New message (text or video)",
      "OR_PICK": "Or pick existing messages",
      "HINT": "The period and the category are taken from the Start Werk Instructie.",
      "ADD": "Add message",
      "SAVE": "Save message",
      "REMOVE": "Remove message"
    },
    "FOLLOW": {
      "TITLE": "Start Werk Instructie",
      "INTRO": "Work through everything below, then sign.",
      "PROGRESS": "{done} of {total} done",
      "EMPTY": "There is nothing to follow on this project today.",
      "LOAD_FAILED": "Could not load the Start Werk Instructie.",
      "RETRY": "Try again",
      "NEXT": "Next step",
      "SIGN_INTRO": "Check your details and sign.",
      "NAME": "Name",
      "DATE": "Date",
      "COMPANY": "Company",
      "FUNCTION": "Function",
      "CLEAR": "Clear",
      "SIGN_AND_FINISH": "Sign and finish",
      "SIGNED": "Start Werk Instructie signed",
      "SIGN_FAILED": "Signing did not go through. Try again."
    },
    "CARD": {
      "HEADING": "Active Start Werk Instructie",
      "STATUS_ACTIVE": "Active",
      "STATUS_PLANNED": "Planned",
      "PERIOD_RANGE": "{from} to {to}",
      "REPEAT_EVERY_ENTRY": "every time the site is entered",
      "REPEAT_FIRST_ENTRY": "only on first entry"
    }
  }
}
